// extracted by mini-css-extract-plugin
export var descriptionHero = "FormPopupModal-module--descriptionHero--5af4f";
export var imgLogo = "FormPopupModal-module--imgLogo--8032e";
export var modal = "FormPopupModal-module--modal--e8a32";
export var modalClose = "FormPopupModal-module--modalClose--5931e";
export var modalContainer = "FormPopupModal-module--modalContainer--59904";
export var swiperSlide = "FormPopupModal-module--swiperSlide--9d9ea";